import {
  analysis,
  buffer,
  cursor,
  guesses,
  guessesUsed,
  HINT_COST,
  hintPurchasedAt,
  marksByGuess,
  puzzle,
  revealingGuessIndex,
  status,
} from "../game/state";
import { Row } from "./Row";

export function Board() {
  const submitted = guesses.value;
  const submittedMarks = marksByGuess.value;
  const isPlaying = status.value === "playing";
  const a = analysis.value;
  const totalRows = puzzle.value.maxGuesses;
  const purchasedAt = hintPurchasedAt.value;
  const slotsUsed = guessesUsed.value;
  const revealingIdx = revealingGuessIndex.value;
  const blank = new Array(a.letterCount).fill(null);

  // Place each row at its visual slot. Guesses submitted before the hint
  // purchase keep their slots; later guesses get pushed down by HINT_COST so
  // a guess remains on the line where the player typed it.
  const slots: (preact.JSX.Element | null)[] = new Array(totalRows).fill(null);

  const slotForGuess = (guessIndex: number) =>
    purchasedAt != null && guessIndex >= purchasedAt
      ? guessIndex + HINT_COST
      : guessIndex;

  for (let r = 0; r < submitted.length; r++) {
    const slot = slotForGuess(r);
    if (slot < totalRows) {
      slots[slot] = (
        <Row
          key={`g-${r}`}
          analysis={a}
          letters={submitted[r]!}
          marks={submittedMarks[r]}
          revealing={r === revealingIdx}
          previousLetters={r > 0 ? submitted[r - 1]! : null}
        />
      );
    }
  }

  if (purchasedAt != null) {
    for (let i = 0; i < HINT_COST; i++) {
      const slot = purchasedAt + i;
      if (slot < totalRows) {
        slots[slot] = <Row key={`p-${i}`} analysis={a} letters={blank} paid />;
      }
    }
  }

  // While a row is mid-reveal, suppress the active row entirely: no
  // carry-forward greens, no cursor — the player can't enter their
  // next guess until the flip-reveal commits.
  if (isPlaying && slotsUsed < totalRows && revealingIdx == null) {
    const activeSlot = slotForGuess(submitted.length);
    if (activeSlot < totalRows) {
      slots[activeSlot] = (
        <Row
          key="active"
          analysis={a}
          letters={buffer.value}
          cursorLetterIndex={cursor.value}
        />
      );
    }
  }

  for (let i = 0; i < totalRows; i++) {
    if (slots[i] == null) {
      slots[i] = <Row key={`f-${i}`} analysis={a} letters={blank} />;
    }
  }

  return <div class="board">{slots}</div>;
}
